import { Checkbox, FormControlLabel, Radio, Stack, Typography } from "@mui/material";
import {
    ChecklistAnswerSubtypeResponse,
    ChecklistAnswerSubtypeDataModel,
    ChecklistItemAnswers,
    ChecklistAnswerItem
} from "../../../../../../types/actionModule/subtypes/checklistAnswerModels";
import { Check, Close } from "@mui/icons-material";

interface Props {
    subtype: ChecklistAnswerSubtypeResponse;
    subtypeData: ChecklistAnswerSubtypeDataModel;
}

export default function ChecklistAnswerSubtypeDetails(props: Props) {
    return <>
        <Stack direction="column">
            {
                props.subtype.checklistItems.map(c => <ChecklistAnswerItemComponent
                    subtype={props.subtype}
                    item={c}
                    answer={props.subtypeData.answers[c.id]}
                />
                )
            }
        </Stack>
    </>
}


interface ChecklistAnswerItemProps {
    subtype: ChecklistAnswerSubtypeResponse;
    item: ChecklistAnswerItem;
    answer: ChecklistItemAnswers;
}

function ChecklistAnswerItemComponent(props: ChecklistAnswerItemProps) {
    switch (props.subtype.checklistAnswerType) {
        case "SingleChoice":
            return <FormControlLabel
                label={props.item.text}
                control={
                    <Radio
                        checked={props.answer === "CheckedPositive"}
                        onChange={() => { }}
                    />
                }
            />;
        case "MultipleChoice":
            return <FormControlLabel
                label={props.item.text}
                control={
                    <Checkbox
                        checked={props.answer === "CheckedPositive"}
                        onChange={() => { }}
                    />
                }
            />;
        case "MultipleChoiceWithDecline":
            if (props.answer === "NotChecked") {
                return <></>
            }

            return <Stack direction={"row"}>
                {props.answer === "CheckedPositive" && <Check sx={{ color: "green" }} />}
                {props.answer === "CheckedNegative" && <Close sx={{ color: "red" }} />}
                <Typography>{props.item.text}</Typography>
            </Stack>;
    }
}